module.exports = __webpack_public_path__ + "static/media/chill-spins-300x100-dark.6bf36e43.png";